import React from "react";
import { joinClasses } from "ds-core/utils";
import { ECImageProps } from "@common/NewImage";
import { Caption } from "@common/DynamicUikit";
import { setWidthParamInImageUrl } from "./helpers";
import style from "./styles.module.css";

export interface ECImagePlusTextVerticalExtraSmallProps
  extends React.HTMLAttributes<HTMLDivElement> {
  media: React.ReactElement<ECImageProps>;
  title?: string;
  description?: string;
  selected?: boolean;
}

export const ECImagePlusTextVerticalExtraSmall: React.FC<
  ECImagePlusTextVerticalExtraSmallProps
> = (props: ECImagePlusTextVerticalExtraSmallProps) => {
  const {
    media,
    title,
    description,
    selected = false,
    className,
    ...restProps
  } = props;

  const mediaArray = Array.isArray(media) ? media : [media];
  const modifiedMedia = mediaArray.map((item) => {
    // this is applicable for the CMS configurations only, hence the check is comparing Image type
    if (item?.props?._type !== "Image") return item;
    const { largeImageUrl, smallMediumImageUrl } = item.props;
    return React.cloneElement(item, {
      // expected optimized width for these variant is 200px as confirmed with Designer
      // implemented as part of ACPF-2112569
      largeImageUrl: setWidthParamInImageUrl(200, largeImageUrl),
      smallMediumImageUrl: setWidthParamInImageUrl(200, smallMediumImageUrl)
    });
  });

  return (
    <div
      className={joinClasses(style.imagePlusTextVerticalExtraSmall, className)}
      role="option"
      aria-selected={selected}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
    >
      <div
        className={joinClasses(
          style.imagePlusTextVerticalExtraSmallImage,
          "ito-margin-bottom-12"
        )}
      >
        {modifiedMedia}
      </div>
      {title && (
        <Caption
          element="h2"
          className={style.imagePlusTextVerticalExtraSmallTitle}
        >
          {title}
        </Caption>
      )}
      {description && (
        <Caption
          element="p"
          className={style.imagePlusTextVerticalExtraSmallDescription}
        >
          {description}
        </Caption>
      )}
    </div>
  );
};
